import Vue from 'vue'
import {
  GET_USER,
  GET_USERS,
  ERROR_XHR,
  DELETE_USER,
  SUCCESS_XHR,
  ADD_USER,
  UPDATE_USER,
  REQUEST_ADD_USER,
  REQUEST_UPDATE_USER
} from '../mutation-types.js'

// TODO use 'user' as a Vue resource
// TODO dispatch instantly, don't wait for server response, rollback if XHR_ERROR

/**
 *
 * @param dispatch
 * @returns {Promise}
 */
export const getUsers = ({ dispatch }) => {
  return new Promise((resolve, reject) => {
    Vue.http
      .get('user')
      .then(
        (response) => {
          dispatch(GET_USERS, response.json())
          resolve()
        },
        (response) => {
          dispatch(ERROR_XHR, response.json())
          reject()
        })
  })
}

/**
 * Get single user
 *
 * @param store
 * @param userId
 * @returns {Promise}
 */
export const getUser = (store, userId) => {
  const sortUsers = (users, userId) => users.filter((user) => Number(user.id) === Number(userId))[0]
  // If users all is empty, launch getUsers action first
  if (!store.state.users.all.length) {
    return getUsers(store).then(() => store.dispatch(GET_USER, sortUsers(store.state.users.all, userId)))
  }
  return new Promise((resolve, reject) => {
    store.dispatch(GET_USER, sortUsers(store.state.users.all, userId))
    resolve()
  })
}

/**
 * Add a new user
 *
 * @param dispatch
 * @param user
 */
export const addUser = ({ dispatch }, user) => {
  dispatch(REQUEST_ADD_USER)
  Vue.http
    .post('user', user)
    .then((response) => {
      dispatch(ADD_USER, user)
    })
}

/**
 * Edit a user
 *
 * @param dispatch
 * @param oldUser The former user data
 * @param newUser The new user data
 */
export const editUser = ({ dispatch }, oldUser, newUser) => {
  dispatch(REQUEST_UPDATE_USER)
  Vue.http
    .put('user/' + newUser.id, newUser)
    .then(
      (response) => {
        dispatch(UPDATE_USER, oldUser, newUser)
      },
      (response) => {
        dispatch(ERROR_XHR, response.json())
      }
    )
}

/**
 * Delete a user
 *
 * @param dispatch
 * @param user
 */
export const deleteUser = ({ dispatch }, user) => {
  dispatch(DELETE_USER, user)
  Vue.http.delete('user/' + user.id)
    .then(
      (response) => {
        dispatch(SUCCESS_XHR, user)
      },
      (response) => {
        dispatch(ERROR_XHR, response.json())
      }
    )
}



// WEBPACK FOOTER //
// ./src/vuex/actions/userActions.js